// §18 adapter: window globals injected at runtime by HTML wrappers or external scripts.
// Third-party injection forces the cast; isolated here so all consumers stay cast-free.

const win = window;
export const setHubspotUtk = value => {
  win.__HUBSPOT_UTK = value;
};
export const setUtAnonId = value => {
  win.__utAnonId = value;
};
export const getI18nManualLang = () => win.I18N_MANUAL_LANG;
export const setI18nManualLang = value => {
  win.I18N_MANUAL_LANG = value;
};